export default {
  metadata: {
    version: '1.0.0',
    id: 'horizontal-stepper-1.0.0',
    name: 'JDSHorizontalStepper'
  },
  hierarchy: {
    container: [
      {
        'step-indicator-container': ['jds_step_item_horizontal']
      },
      {
        'stepper-children-container': ['stepper-content-slot']
      }
    ]
  },
  base: {
    container: {
      gap: '{h_0}',
      'flex-direction': '{h_1}',
      size: '{h_2}'
    },
    'step-indicator-container': {
      'flex-direction': '{h_3}',
      'justify-content': '{h_4}',
      'align-items': '{h_5}',
      size: '{h_6}',
      'padding-left': '{h_7}',
      'padding-right': '{h_8}'
    },
    jds_step_item_horizontal: {
      flex: 1
    },
    'stepper-children-container': {
      size: '{h_9}',
      'flex-direction': '{h_10}',
      'justify-content': '{h_11}',
      'align-items': '{h_12}',
      'enter-animation-name': 'slideHorizontallyToRight',
      'exit-animation-name': 'slideHorizontallyToLeft',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500
    }
  },
  api: {
    data: {
      container: {
        'max-width': {
          name: 'maxWidth',
          type: 'size'
        }
      },
      'step-indicator-container': {
        value: {
          name: 'stepItems',
          type: 'list',
          object: {
            state: 'JDSStepperDot.state',
            label: 'string',
            index: 'string',
            icon: 'icon',
            activeState: 'JDSStepperDot.activeState',
            direction: 'JDSHorizontalStepItem.direction'
          }
        }
      },
      jds_step_item_horizontal: {
        state: {
          type: 'JDSStepperDot.state',
          name: 'stepItems.state'
        },
        label: {
          type: 'string',
          name: 'stepItems.label'
        },
        index: {
          type: 'string',
          name: 'stepItems.index'
        },
        icon: {
          type: 'icon',
          name: 'stepItems.icon'
        },
        direction: {
          type: 'JDSHorizontalStepItem.direction',
          name: 'stepItems.direction'
        },
        activeState: {
          type: 'JDSStepperDot.activeState',
          name: 'stepItems.activeState'
        },
        itemsType: {
          type: 'JDSStepperDot.itemsType',
          name: 'itemsType'
        }
      }
    },
    children: {
      'stepper-content-slot': {
        name: 'content',
        accepts: ['template'],
        max: 1
      }
    },
    a11y: {
      'step-indicator-container': {
        name: 'stepItems',
        repeating: {
          ariaLabel: 'stepItemAriaLabel',
          ariaCurrent: '_ariaCurrent'
        },
        properties: {
          role: {
            value: 'list'
          }
        }
      },
      jds_step_item_horizontal: {
        properties: {
          ariaLabel: 'stepItems.stepItemAriaLabel',
          ariaCurrent: 'stepItems._ariaCurrent'
        }
      }
    }
  }
};
